import { FormControl } from '@startuptools/ui/FormControl';
import { FormLabel } from '@startuptools/ui/FormLabel';
import { Select } from '@startuptools/ui/Select';
import { Stack } from '@startuptools/ui/Stack';
import { Input } from '@startuptools/ui/Input';
import { Option } from '@startuptools/ui/Option';
import { type GqlShareClass } from '../../graphql/react-operations';
import { Trans } from '@lingui/react';
import { type Control, Controller, type UseFormRegister, type UseFormWatch } from 'react-hook-form';

const OTHER_NAME = 'Other';

export interface FormInputs {
  selectedShareClassName: string | null;
  newShareClassName: string;
  newShareClassVoteWeight: string;
  [k: string]: unknown;
}

type Watch<T extends FormInputs = FormInputs> = UseFormWatch<T>;
type Register<T extends FormInputs = FormInputs> = UseFormRegister<T>;

export const SelectShareClass = ({
  watch,
  register,
  shareClasses,
  loading,
  control,
  disabledShareClasses,
}: {
  watch: Watch;
  register: Register;
  shareClasses: GqlShareClass[];
  defaultShareClassName: string | undefined;
  loading: boolean;
  control: Control<FormInputs>;
  disabledShareClasses: string[];
}) => {
  const selectedShareClassName = watch('selectedShareClassName');
  return (
    <Stack gap={2}>
      <FormControl>
        <FormLabel id="share-class-label">
          <Trans id="Share class" />
        </FormLabel>

        <Controller
          name="selectedShareClassName"
          control={control}
          render={({ field: { value, ...props } }) => (
            <Select
              value={value}
              onChange={(_e, value) => {
                return props.onChange(value);
              }}
              disabled={loading}
            >
              {shareClasses.map(sc => (
                <Option key={sc.name} value={sc.name} disabled={disabledShareClasses.includes(sc.name)}>
                  {sc.name} (<Trans id="vote weight:" /> {sc.voteWeight})
                </Option>
              ))}
              <Option key={OTHER_NAME} value={OTHER_NAME}>
                <Trans id={OTHER_NAME} />
              </Option>
            </Select>
          )}
        />
      </FormControl>
      {selectedShareClassName === OTHER_NAME && (
        <>
          <FormControl>
            <FormLabel>
              <Trans id="Share class name" />
            </FormLabel>
            <Input {...register('newShareClassName')} disabled={loading} required />
          </FormControl>
          <FormControl>
            <FormLabel>
              <Trans id="Share class weight" />
            </FormLabel>
            <Input {...register('newShareClassVoteWeight')} disabled={loading} required />
          </FormControl>
        </>
      )}
    </Stack>
  );
};
